import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'

import { Link } from 'react-scroll'

import './Navigation.css'

class Navigation extends Component {
  constructor (props) {
    super(props)

    this.closeDrawer = this.closeDrawer.bind(this)
  }

  closeDrawer() {
    if (this.props.onRef) {
      this.props.onRef({
        sideNav: false
      })
    }
  }

  getMenu(soft) {
    return soft ? <Grid container direction={this.props.vertical ? 'column' : 'row'}>
      <li className="nav-item">
        <Link className="nav-link" activeClass="active" to="home" spy={true} smooth={true} duration={500} onClick={this.closeDrawer}>HOME</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" activeClass="active" to="approach" spy={true} smooth={true} duration={500} onClick={this.closeDrawer}>APPROACH</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" activeClass="active" to="services" spy={true} smooth={true} duration={500} onClick={this.closeDrawer}>SERVICES</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" activeClass="active" to="news" spy={true} smooth={true} duration={500} onClick={this.closeDrawer}>NEWS</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" activeClass="active" to="contact" spy={true} smooth={true} duration={500} onClick={this.closeDrawer}>CONTACT</Link>
      </li>
    </Grid> :
      <Grid container direction={this.props.vertical ? 'column' : 'row'}>
        <li className="nav-item">
          <a className="nav-link" href="/">HOME</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/#approach">APPROACH</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/#services">SERVICES</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/#about">ABOUT</a>
        </li>
        <li className="nav-item">
          <a className="nav-link active" href="/#news">NEWS</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/#contact">CONTACT</a>
        </li>
      </Grid>
  }

  render() {
    return (
      <nav className="nav">
        <ul className={`nav-menu ${this.props.mini ? 'mini' : ''} ${this.props.vertical ? 'vertical' : ''}`}>
          {this.getMenu(this.props.soft)}
        </ul>
      </nav >
    )
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js